import React, { useState, useEffect, useRef } from 'react';
import { api, useServer } from '../contexts/ServerContext';
import toast from 'react-hot-toast';
import { 
  Search, 
  User, 
  UserCheck, 
  UserX, 
  Clock,
  AlertTriangle,
  Ban,
  LogOut,
  Zap,
  MessageCircleOff,
  MicOff,
  Monitor,
  ArrowUpCircle,
  Gift,
  Check,
  Shield,
  Crown,
} from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { getCachedAvatar, getCachedDisplayName, updateCachedDisplayName, normalizeSteamId } from '../utils/helpers';
import { Cat } from 'lucide-react';
import { steamIdTo64 } from '../utils/helpers';
import FogRawGLBackground from './FogRawGLBackground';
import PlayerTagsDisplay from './PlayerTagsDisplay';
import ScreengrabLightbox from './ScreengrabLightbox';

function Players() {
  const [players, setPlayers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [onlineFilter, setOnlineFilter] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [showActionModal, setShowActionModal] = useState(false);
  const [actionType, setActionType] = useState('');
  const [actionReason, setActionReason] = useState('');
  const [actionDuration, setActionDuration] = useState(0);
  const [screengrabModal, setScreengrabModal] = useState({ open: false, image: '', key: '' });
  const [actionDisabled, setActionDisabled] = useState(false);
  const [actionDisabledTimeout, setActionDisabledTimeout] = useState(null);
  const actionInProgress = useRef(false);
  const [modalActionInProgress, setModalActionInProgress] = useState(false);
  const { server } = useServer();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [avatars, setAvatars] = useState({});
  const [names, setNames] = useState({});

  const slayerRanks = [
    { value: 1, label: 'Midzunoto' },
    { value: 2, label: 'Midzunoe' },
    { value: 3, label: 'Kanoto' },
    { value: 4, label: 'Kanoe' },
    { value: 5, label: 'Tsuchinoto' },
    { value: 6, label: 'Tsuchinoe' },
    { value: 7, label: 'Hinoto' },
    { value: 8, label: 'Hinoe' },
    { value: 9, label: 'Kinoto' },
    { value: 10, label: 'Kinoe' },
    { value: 11, label: 'Hashira' },
  ];

  const demonRanks = [
    { value: 1, label: 'Otokuma' },
    { value: 2, label: 'Demon' },
    { value: 3, label: 'Keykon' },
    { value: 4, label: 'Hofuma' },
    { value: 5, label: 'Chisuma' },
    { value: 6, label: 'Chikuma' },
    { value: 7, label: 'Asakuma' },
    { value: 8, label: 'Hobura' },
    { value: 9, label: 'Shateigashira' },
    { value: 10, label: 'Wakagashira' },
    { value: 11, label: 'Tsukomon' },
    { value: 12, label: 'Shiko' },
  ];

  const [showWhitelistModal, setShowWhitelistModal] = useState(false);
  const [whitelistModalPlayer, setWhitelistModalPlayer] = useState(null);
  const [whitelistProfession, setWhitelistProfession] = useState('');
  const [whitelistLoading, setWhitelistLoading] = useState(false);

  const [showSetRankModal, setShowSetRankModal] = useState(false);
  const [setRankModalPlayer2, setSetRankModalPlayer2] = useState(null);
  const [selectedFaction, setSelectedFaction] = useState('');
  const [selectedRankNumber, setSelectedRankNumber] = useState('');
  const [setRankLoading2, setSetRankLoading2] = useState(false);

  const rankOptions = [
    { value: 'superadmin', label: 'Суперадмин' },
    { value: 'yufuadmin', label: 'Юфуадмин' },
    { value: 'curator', label: 'Куратор' },
    { value: 'seniorstaff', label: 'Старший стафф' },
    // Админ отдел
    { value: 'chiefadmin', label: 'Гл. админ' },
    { value: 'depadmin', label: 'Зам. гл. админа' },
    { value: 'sadmin', label: 'Старший администратор' },
    { value: 'admins', label: 'Администратор' },
    { value: 'lowadmin', label: 'Младший администратор' },
    // Ивент отдел
    { value: 'chiefivent', label: 'Гл. ивентолог' },
    { value: 'depivent', label: 'Зам. гл. ивентолога' },
    { value: 'sivent', label: 'Старший ивентолог' },
    { value: 'ivent', label: 'Ивентолог' },
    { value: 'lowivent', label: 'Младший ивентолог' },
    // РП отдел
    { value: 'rpcurator', label: 'Куратор РП' },
    { value: 'deprp', label: 'Зам. гл. РП' },
    { value: 'user', label: 'Игрок'}
  ];

  const [showRankModal, setShowRankModal] = useState(false);
  const [rankModalPlayer, setRankModalPlayer] = useState(null);
  const [selectedRank, setSelectedRank] = useState('');
  const [rankLoading, setRankLoading] = useState(false);
  const [rankReason, setRankReason] = useState('');

  const [showGivePifsModal, setShowGivePifsModal] = useState(false);
  const [givePifsAmount, setGivePifsAmount] = useState('');
  const [givePifsLoading, setGivePifsLoading] = useState(false);
  const [givePifsPlayer, setGivePifsPlayer] = useState(null);
  const [givePifsTake, setGivePifsTake] = useState(false);

  useEffect(() => {
    setCurrentPage(1);
  }, [search, onlineFilter]);

  useEffect(() => {
    fetchPlayers();
  }, [currentPage, server, search, onlineFilter]);

  useEffect(() => {
    return () => {
      if (actionDisabledTimeout) clearTimeout(actionDisabledTimeout);
    };
  }, []);

  useEffect(() => {
    if (!players.length) return;
    const ids = players.map(p => p.steamId).filter(Boolean);
    ids.forEach(async (steamId) => {
      const id64 = steamIdTo64(steamId);
      if (!id64) return;
      if (!avatars[steamId]) {
        try {
          const url = await getCachedAvatar(id64, async () => {
            const resp = await api.get(`/api/steam/avatar/${id64}`);
            return resp.data.avatar;
          });
          setAvatars(prev => ({ ...prev, [steamId]: url }));
        } catch {
          setAvatars(prev => ({ ...prev, [steamId]: null }));
        }
      }
      if (!names[steamId]) {
        try {
          const displayName = await getCachedDisplayName(id64, async () => {
            const resp = await api.get(`/api/players/${steamId}`);
            return resp.data.displayName || resp.data.name || steamId;
          });
          setNames(prev => ({ ...prev, [steamId]: displayName }));
        } catch {
          setNames(prev => ({ ...prev, [steamId]: steamId }));
        }
      }
    });
  }, [players]);

  const fetchPlayers = async () => {
    try {
      const params = new URLSearchParams({
        page: currentPage,
        limit: 20,
        search: search,
        server: server
      });
      
      if (onlineFilter !== 'all') {
        params.append('online', onlineFilter);
      }
      
      const response = await api.get(`/api/players?${params}`, { withCredentials: true });
      setPlayers(response.data.players);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      toast.error('Ошибка при загрузке игроков');
    } finally {
      setLoading(false);
    }
  };

  const handleAction = async () => {
    if (!selectedPlayer || !actionType) return;
    if (actionDisabled || actionInProgress.current || modalActionInProgress) return;
    setModalActionInProgress(true);
    actionInProgress.current = true;
    try {
      await api.post(`/api/admin/action`, {
        action: actionType,
        target: selectedPlayer.steamId,
        reason: actionReason,
        duration: actionDuration
      }, { withCredentials: true });

      toast.success('Действие выполнено');
      setShowActionModal(false);
      setSelectedPlayer(null);
      setActionType('');
      setActionReason('');
      setActionDuration(0);
      fetchPlayers();
    } catch (error) {
      let msg = error?.response?.data?.details || 'Ошибка при выполнении действия';
      if (error?.response?.status === 429 && error?.response?.data?.details) {
        const d = error.response.data.details;
        msg = `Лимит: ${d.actions}/${d.max}. До сброса: ${d.nextResetSec} сек.`;
        setActionDisabled(true);
        if (actionDisabledTimeout) clearTimeout(actionDisabledTimeout);
        const timeout = setTimeout(() => setActionDisabled(false), d.nextResetSec * 1000);
        setActionDisabledTimeout(timeout);
      }
      toast.error(msg);
    } finally {
      actionInProgress.current = false;
      setModalActionInProgress(false);
    }
  };
  const handleActionDirect = async (actionType, player) => {
    if (actionDisabled || actionInProgress.current) return;
    actionInProgress.current = true;
    try {
      await api.post(`/api/admin/action`, {
        action: actionType,
        target: player.steamId,
        reason: '',
        duration: 0
      }, { withCredentials: true });
  
      toast.success('Действие выполнено');
      fetchPlayers();
    } catch (error) {
      let msg = error?.response?.data?.details || 'Ошибка при выполнении действия';
      if (error?.response?.status === 429 && error?.response?.data?.details) {
        const d = error.response.data.details;
        msg = `Лимит: ${d.actions}/${d.max}. До сброса: ${d.nextResetSec} сек.`;
        setActionDisabled(true);
        if (actionDisabledTimeout) clearTimeout(actionDisabledTimeout);
        const timeout = setTimeout(() => setActionDisabled(false), d.nextResetSec * 1000);
        setActionDisabledTimeout(timeout);
      }
      toast.error(msg);
    } finally {
      actionInProgress.current = false;
    }
  };

  const handleScreengrab = async (player) => {
    const key = uuidv4();
    const sid = normalizeSteamId(player.steamId);
    try {
      await api.post(`/api/admin/action`, {
        action: `screengrab"${sid}"${key}`,
        target: sid,
        reason: '',
        duration: 0
      }, { withCredentials: true });
      // Ожидание скрина через поллинг (или заменить на websocket при наличии)
      pollScreengrab(key);
    } catch (error) {
      toast.error('Ошибка при выполнении действия');
    }
  };

  const pollScreengrab = (key, attempts = 0) => {
    if (attempts > 45) { // ~45 секунд
      toast.error('Скриншот не получен');
      return;
    }
    api.get(`/api/admin/screengrab?key=${key}`, { withCredentials: true })
      .then(res => {
        if (res.data && res.data.image) {
          setScreengrabModal({ open: true, image: res.data.image, key });
        } else {
          setTimeout(() => pollScreengrab(key, attempts + 1), 1000);
        }
      })
      .catch(() => {
        setTimeout(() => pollScreengrab(key, attempts + 1), 1000);
      });
  };

  const getStatusIcon = (isOnline) => {
    return isOnline ? (
      <UserCheck className="h-4 w-4 text-green-500" />
    ) : (
      <UserX className="h-4 w-4 text-gray-500" />
    );
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString('ru-RU', { timeZone: 'Europe/Moscow' });
  };

  const formatPlayTime = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours}ч ${mins}м`;
  };

  // Пример функции смены RP-имени (можно вызывать из любого места):
  async function changeRpName(steamId, newName) {
    try {
      await api.post(`/api/players/${steamId}/rpname`, { rpName: newName });
      updateCachedDisplayName(steamId, newName);
      toast.success('RP-имя успешно изменено');
    } catch (e) {
      toast.error('Ошибка при смене RP-имени');
    }
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <>
      <FogRawGLBackground />
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-gmod-white ml-4">Управление игроками</h1>
          <p className="text-gmod-white opacity-60 mt-2 ml-4">Просмотр и управление игроками сервера</p>
        </div>

        {/* Filters */}
        <div className="bg-gmod-dark rounded-lg p-6 border border-gmod-lighterer">
          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex-1">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gmod-white opacity-60" />
                <input
                  type="text"
                  placeholder="Поиск по имени или Steam ID..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 bg-gmod-lighter border border-gmod-lighterer rounded-md text-gmod-white placeholder-gmod-white placeholder-opacity-40 focus:outline-none focus:ring-2 focus:ring-theme-primary"
                />
              </div>
            </div>
            <div>
              <select
                value={onlineFilter}
                onChange={(e) => setOnlineFilter(e.target.value)}
                className="px-4 py-2 bg-gmod-lighter border border-gmod-lighterer rounded-md text-gmod-white focus:outline-none focus:ring-2 focus:ring-theme-primary"
              >
                <option value="all">Все игроки</option>
                <option value="true">Онлайн</option>
                <option value="false">Оффлайн</option>
              </select>
            </div>
          </div>
        </div>

        {/* Players List */}
        <div className="bg-gmod-dark rounded-lg border border-gmod-lighterer">
          <div className="px-6 py-4 border-b border-gmod-lighterer">
            <h2 className="text-lg font-semibold text-gmod-white">Список игроков</h2>
          </div>
          <div className="p-6">
            {players.length === 0 ? (
              <p className="text-gmod-white opacity-60 text-center py-8">Игроки не найдены</p>
            ) : (
              <div className="space-y-4">
                {players.map((player) => (
                  <div key={player._id} className="flex flex-col md:flex-row items-stretch justify-between p-4 bg-gmod-lighter rounded-lg hover:bg-gmod-dark transition-colors group gap-4 cursor-pointer"  onClick={() => navigate(`/players/${player.steamId}`)}>
                    {/* Левая секция: инфо */}
                    <div className="flex flex-col items-center md:items-start flex-1 min-w-0">
                      <span className="flex items-center min-w-[48px] w-12 h-12 justify-center mb-2">
                        {avatars[player.steamId] ? (
                          <img
                            src={avatars[player.steamId]}
                            alt="avatar"
                            className={`w-16 ml-2 h-16 min-w-[64px] rounded-full border-2 bg-gmod-dark object-cover ${player.isOnline ? 'border-green-400' : 'border-theme-primary'}`}
                          />
                        ) : (
                          <User className="w-16 h-16 min-w-[64px] text-gmod-white opacity-40" />
                        )}
                      </span>
                      <div className="flex flex-col min-w-0 items-center md:items-start">
                        <span className="text-gmod-white font-bold text-lg truncate max-w-[220px]">{player.displayName || player.name || names[player.steamId] || player.steamId}</span>
                        <span className="text-gmod-white opacity-60 text-xs font-mono truncate">{player.steamId}</span>
                        <span className="text-gmod-white opacity-80 text-sm mt-1">Последний заход: {formatDate(player.lastSeen)}</span>
                        <div className="mt-2">
                          <PlayerTagsDisplay steamId={player.steamId} />
                        </div>
                      </div>
                    </div>
                    {/* Правая секция: две группы действий */}
                    <div className="flex flex-col gap-3 md:w-64 justify-between items-end">
                      <div>
                        <div className="text-xs text-gmod-white opacity-60 mb-1 text-right">Основные действия</div>
                        <div className="flex flex-row flex-wrap gap-2 justify-end">
                          <button
                            onClick={e => {
                              e.stopPropagation();
                              setSelectedPlayer(player);
                              setActionType('kick');
                              setShowActionModal(true);
                            }}
                            className="p-2 text-gmod-lightest hover:bg-theme-primary hover:text-gmod-white rounded-md transition-colors"
                            title="Кикнуть"
                          >
                            <LogOut className="h-4 w-4" />
                          </button>
                          <button
                            onClick={e => {
                              e.stopPropagation();
                              setSelectedPlayer(player);
                              setActionType('ban');
                              setShowActionModal(true);
                            }}
                            className="p-2 text-theme-primary hover:bg-theme-primary hover:text-gmod-white rounded-md transition-colors"
                            title="Забанить"
                          >
                            <Ban className="h-4 w-4" />
                          </button>
                          <button
                            onClick={e => {
                              e.stopPropagation();
                              setSelectedPlayer(player);
                              setActionType('slay');
                              setShowActionModal(true);
                            }}
                            className="p-2 text-theme-primary hover:bg-theme-primary-hover hover:text-gmod-white rounded-md transition-colors"
                            title="Убить"
                          >
                            <Zap className="h-4 w-4" />
                          </button>
                          <button
                            onClick={e => {
                              e.stopPropagation();
                              setSelectedPlayer(player);
                              setActionType('mute');
                              setShowActionModal(true);
                            }}
                            className="p-2 text-gmod-blue hover:bg-gmod-blue hover:text-gmod-white rounded-md transition-colors"
                            title="Замутить"
                          >
                            <MicOff className="h-4 w-4" />
                          </button>
                          <button
                            onClick={e => {
                              e.stopPropagation();
                              setSelectedPlayer(player);
                              setActionType('gag');
                              setShowActionModal(true);
                            }}
                            className="p-2 text-gmod-blue hover:bg-gmod-blue hover:text-gmod-white rounded-md transition-colors"
                            title="Гаг"
                          >
                            <MessageCircleOff className="h-4 w-4"/>
                          </button>
                          <button
                            onClick={e => {
                              e.stopPropagation();
                              handleScreengrab(player);
                            }}
                            className="p-2 text-gmod-red hover:bg-theme-primary-hover hover:text-gmod-white rounded-md transition-colors"
                            title="Снимок экрана"
                          >
                            <Monitor className="h-4 w-4"/>
                          </button>
                        </div>
                      </div>
                      <div>
                        <div className="text-xs text-gmod-white opacity-60 mb-1 text-right">Специальное</div>
                        <div className="flex flex-row flex-wrap gap-2 justify-end">
                          <button
                            onClick={e => {
                              e.stopPropagation();
                              setRankModalPlayer(player);
                              setShowRankModal(true);
                              setSelectedRank('');
                            }}
                            className="p-2 text-gmod-blue hover:bg-gmod-blue hover:text-gmod-white rounded-md transition-colors"
                            title="Установить ранг"
                          >
                            <ArrowUpCircle className="h-4 w-4" />
                          </button>

                          <button
                            onClick={e => {
                              e.stopPropagation();
                              setSetRankModalPlayer2(player);
                              setSelectedFaction('');
                              setSelectedRankNumber('');
                              setShowSetRankModal(true);
                            }}
                            className="p-2 text-gmod-yellow hover:bg-gmod-yellow hover:text-gmod-white rounded-md transition-colors"
                            title="SetFactionRank"
                          >
                            <Crown className="h-4 w-4" />
                          </button>
                          <button
                            onClick={e => {
                              e.stopPropagation();
                              setGivePifsPlayer(player);
                              setGivePifsAmount('');
                              setGivePifsTake(false);
                              setShowGivePifsModal(true);
                            }}
                            className="p-2 text-theme-primary hover:bg-theme-primary hover:text-gmod-white rounded-md transition-colors"
                            title="Выдать Юфики"
                          >
                            <Gift className="h-4 w-4" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="flex justify-center space-x-2">
            <button
              onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
              disabled={currentPage === 1}
              className="px-4 py-2 bg-gmod-lighter text-gmod-white rounded-md disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gmod-lighterer"
            >
              Назад
            </button>
            <span className="px-4 py-2 text-gmod-white">
              {currentPage} из {totalPages}
            </span>
            <button
              onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
              disabled={currentPage === totalPages}
              className="px-4 py-2 bg-gmod-lighter text-gmod-white rounded-md disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gmod-lighterer"
            >
              Вперед
            </button>
          </div>
        )}

        {/* Action Modal */}
        {showActionModal && selectedPlayer && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-gmod-dark rounded-lg p-6 w-full max-w-md border border-gmod-lighterer">
              <h3 className="text-lg font-semibold text-gmod-white mb-4">
                {actionType === 'kick' && 'Кикнуть игрока'}
                {actionType === 'ban' && 'Забанить игрока'}
                {actionType === 'slay' && 'Убить игрока'}
                {actionType === 'mute' && 'Замутить игрока'}
                {actionType === 'gag' && 'Гагнуть игрока'}
              </h3>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gmod-white opacity-60 mb-2">
                    Игрок
                  </label>
                  <p className="text-gmod-white">{selectedPlayer.displayName}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gmod-white opacity-60 mb-2">
                    Причина
                  </label>
                  <input
                    type="text"
                    value={actionReason}
                    onChange={(e) => setActionReason(e.target.value)}
                    className="w-full px-3 py-2 bg-gmod-lighter border border-gmod-lighterer rounded-md text-gmod-white focus:outline-none focus:ring-2 focus:ring-theme-primary"
                    placeholder="Укажите причину..."
                  />
                </div>
                {actionType === 'ban' && (
                  <div>
                    <label className="block text-sm font-medium text-gmod-white opacity-60 mb-2">
                      Длительность (минуты, 0 = навсегда)
                    </label>
                    <input
                      type="number"
                      value={actionDuration}
                      onChange={(e) => setActionDuration(parseInt(e.target.value) || e.target.value)}
                      className="w-full px-3 py-2 bg-gmod-lighter border border-gmod-lighterer rounded-md text-gmod-white focus:outline-none focus:ring-2 focus:ring-theme-primary"
                      min="0"
                    />
                  </div>
                )}
                {(actionType === 'mute' || actionType === 'gag') && (
                  <div>
                    <label className="block text-sm font-medium text-gmod-white opacity-60 mb-2">
                      Длительность (минуты, 0 = навсегда) 
                    </label>
                    <input
                      type="number"
                      value={actionDuration}
                      onChange={(e) => setActionDuration(parseInt(e.target.value) || e.target.value)}
                      className="w-full px-3 py-2 bg-gmod-lighter border border-gmod-lighterer rounded-md text-gmod-white focus:outline-none focus:ring-2 focus:ring-theme-primary"
                      min="0"
                    />
                  </div>
                )}
                <div className="flex space-x-3 pt-4">
                  <button
                    onClick={() => setShowActionModal(false)}
                    className="flex-1 px-4 py-2 bg-gmod-lighterer text-gmod-white rounded-md hover:bg-gmod-lightest"
                  >
                    Отмена
                  </button>
                  <button
                    onClick={handleAction}
                    disabled={modalActionInProgress}
                    className="flex-1 px-4 py-2 bg-theme-primary text-gmod-white rounded-md hover:bg-theme-primary-hover"
                  >
                    Выполнить
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {showRankModal && rankModalPlayer && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-gmod-dark rounded-lg p-6 w-full max-w-md border border-gmod-lighterer">
              <h3 className="text-lg font-semibold text-gmod-white mb-4">Установить ранг игроку</h3>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gmod-white opacity-60 mb-2">Игрок</label>
                  <p className="text-gmod-white">{rankModalPlayer.displayName} ({rankModalPlayer.steamId})</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gmod-white opacity-60 mb-2">Ранг</label>
                  <select
                    value={selectedRank}
                    onChange={e => setSelectedRank(e.target.value)}
                    className="w-full px-3 py-2 bg-gmod-lighter border border-gmod-lighterer rounded-md text-gmod-white focus:outline-none focus:ring-2 focus:ring-theme-primary"
                  >
                    <option value="">Выберите ранг...</option>
                    {rankOptions.map((opt) => {
                      let disabled = false;
                      if (user && user.rank) {
                        const myIdx = rankOptions.findIndex(r => r.value === user.rank);
                        const optIdx = rankOptions.findIndex(r => r.value === opt.value);
                        if (optIdx < myIdx) disabled = true; // только равные и выше себя
                      }
                      return (
                        <option key={opt.value} value={opt.value} disabled={disabled}>{opt.label}</option>
                      );
                    })}
                  </select>
                </div>
                <div className="flex space-x-3 pt-4">
                  <button
                    onClick={() => setShowRankModal(false)}
                    className="flex-1 px-4 py-2 bg-gmod-lighterer text-gmod-white rounded-md hover:bg-gmod-lightest"
                  >
                    Отмена
                  </button>
                  <button
                    onClick={async () => {
                      if (!selectedRank) return;
                      setRankLoading(true);
                      try {
                        await api.post(`/api/admin/set-rank`, {
                          target: rankModalPlayer.steamId,
                          newRank: selectedRank
                        }, { withCredentials: true });
                        toast.success('Команда на выдачу ранга отправлена');
                        setShowRankModal(false);
                        setRankModalPlayer(null);
                        setSelectedRank('');
                        fetchPlayers();
                      } catch (e) {
                        toast.error(e?.response?.data?.error || 'Ошибка при выдаче ранга');
                      } finally {
                        setRankLoading(false);
                      }
                    }}
                    disabled={rankLoading || !selectedRank}
                    className="flex-1 px-4 py-2 bg-theme-primary text-gmod-white rounded-md hover:bg-theme-primary-hover"
                  >
                    {rankLoading ? '...' : 'Выдать'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {screengrabModal.open && (
          <ScreengrabLightbox
            image={screengrabModal.image}
            title="Скриншот игрока"
            onClose={() => setScreengrabModal({ open: false, image: '', key: '' })}
          />
        )}

        {showGivePifsModal && givePifsPlayer && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50">
            <div className="bg-gmod-dark rounded-lg p-6 border border-gmod-lighterer max-w-lg w-full">
              <div className="text-lg font-bold text-theme-primary mb-4">Выдача Юфиков для {givePifsPlayer.displayName}</div>
              <input
                type="number"
                className="w-full px-4 py-2 mb-4 bg-gmod-lighter border border-gmod-lighterer rounded-md text-gmod-white placeholder-gmod-white placeholder-opacity-40 focus:outline-none focus:ring-2 focus:ring-theme-primary"
                placeholder="Количество Юфиков"
                value={givePifsAmount}
                onChange={e => setGivePifsAmount(e.target.value)}
                disabled={givePifsLoading}
              />
              <label className="flex items-center mb-4 select-none cursor-pointer group">
                <span className="relative inline-block w-6 h-6 mr-2 align-middle">
                  <input
                    type="checkbox"
                    checked={givePifsTake}
                    onChange={e => setGivePifsTake(e.target.checked)}
                    className="absolute w-6 h-6 opacity-0 cursor-pointer z-10"
                    disabled={givePifsLoading}
                  />
                  <span className={`block w-6 h-6 rounded border-2 transition-colors duration-150 ${givePifsTake ? 'bg-theme-primary border-theme-primary' : 'bg-gmod-lighter border-gmod-lighterer'} group-hover:border-theme-primary`}></span>
                  {givePifsTake && (
                    <Check className="absolute left-1 top-1 w-4 h-4 text-gmod-white pointer-events-none" />
                  )}
                </span>
                <span className="text-gmod-white">Забрать?</span>
              </label>
              <div className="flex space-x-4">
                <button
                  className="px-4 py-2 bg-theme-primary text-gmod-white rounded hover:bg-theme-primary-hover"
                  disabled={givePifsLoading || !givePifsAmount}
                  onClick={async () => {
                    setGivePifsLoading(true);
                    try {
                      await api.post(`/api/admin/give-pifs`, {
                        target: givePifsPlayer.steamId,
                        amount: parseInt(givePifsAmount),
                        take: givePifsTake ? 1 : 0
                      }, { withCredentials: true });
                      setShowGivePifsModal(false);
                      setGivePifsAmount('');
                      setGivePifsPlayer(null);
                      setGivePifsTake(false);
                      toast.success('Юфики успешно выданы');
                    } catch (e) {
                      toast.error(e?.response?.data?.error || 'Ошибка при выдаче Юфиков');
                    } finally {
                      setGivePifsLoading(false);
                    }
                  }}
                >
                  Выдать
                </button>
                <button
                  className="px-4 py-2 bg-gmod-lighter text-gmod-white rounded hover:bg-theme-primary"
                  onClick={() => setShowGivePifsModal(false)}
                  disabled={givePifsLoading}
                >
                  Отмена
                </button>
              </div>
            </div>
          </div>
        )}

        {showWhitelistModal && whitelistModalPlayer && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-gmod-dark rounded-lg p-6 w-full max-w-md border border-gmod-lighterer">
              <h3 className="text-lg font-semibold text-gmod-white mb-4">Set WhiteList</h3>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gmod-white opacity-60 mb-2">Игрок</label>
                  <p className="text-gmod-white">{whitelistModalPlayer.displayName} ({whitelistModalPlayer.steamId})</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gmod-white opacity-60 mb-2">Название профессии</label>
                  <input
                    type="text"
                    value={whitelistProfession}
                    onChange={(e) => setWhitelistProfession(e.target.value)}
                    className="w-full px-3 py-2 bg-gmod-lighter border border-gmod-lighterer rounded-md text-gmod-white focus:outline-none focus:ring-2 focus:ring-theme-primary"
                    placeholder="Введите название профессии..."
                  />
                </div>
                <div className="flex space-x-3 pt-4">
                  <button
                    onClick={() => setShowWhitelistModal(false)}
                    className="flex-1 px-4 py-2 bg-gmod-lighterer text-gmod-white rounded-md hover:bg-gmod-lightest"
                  >
                    Отмена
                  </button>
                  <button
                    onClick={async () => {
                      if (!whitelistProfession.trim()) return;
                      setWhitelistLoading(true);
                      try {
                        await api.post(`/api/commands`, {
                          command: `SetWhitelist"${whitelistModalPlayer.steamId}"${whitelistProfession.trim()}`,
                          target: whitelistModalPlayer.steamId,
                          reason: '',
                          duration: 0,
                          type: 'whitelist'
                        }, { withCredentials: true });
                        toast.success('Команда SetWhitelist отправлена');
                        setShowWhitelistModal(false);
                        setWhitelistModalPlayer(null);
                        setWhitelistProfession('');
                        fetchPlayers();
                      } catch (e) {
                        toast.error(e?.response?.data?.error || 'Ошибка при выполнении команды');
                      } finally {
                        setWhitelistLoading(false);
                      }
                    }}
                    disabled={whitelistLoading || !whitelistProfession.trim()}
                    className="flex-1 px-4 py-2 bg-theme-primary text-gmod-white rounded-md hover:bg-theme-primary-hover"
                  >
                    {whitelistLoading ? '...' : 'Выполнить'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {showSetRankModal && setRankModalPlayer2 && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-gmod-dark rounded-lg p-6 w-full max-w-md border border-gmod-lighterer">
              <h3 className="text-lg font-semibold text-gmod-white mb-4">Set Rank</h3>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gmod-white opacity-60 mb-2">Игрок</label>
                  <p className="text-gmod-white">{setRankModalPlayer2.displayName} ({setRankModalPlayer2.steamId})</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gmod-white opacity-60 mb-2">Фракция</label>
                  <select
                    value={selectedFaction}
                    onChange={(e) => {
                      setSelectedFaction(e.target.value);
                      setSelectedRankNumber('');
                    }}
                    className="w-full px-3 py-2 bg-gmod-lighter border border-gmod-lighterer rounded-md text-gmod-white focus:outline-none focus:ring-2 focus:ring-theme-primary"
                  >
                    <option value="">Выберите фракцию...</option>
                    <option value="slayer">Slayer</option>
                    <option value="demon">Demon</option>
                  </select>
                </div>
                {selectedFaction && (
                  <div>
                    <label className="block text-sm font-medium text-gmod-white opacity-60 mb-2">Ранг</label>
                    <select
                      value={selectedRankNumber}
                      onChange={(e) => setSelectedRankNumber(e.target.value)}
                      className="w-full px-3 py-2 bg-gmod-lighter border border-gmod-lighterer rounded-md text-gmod-white focus:outline-none focus:ring-2 focus:ring-theme-primary"
                    >
                      <option value="">Выберите ранг...</option>
                      {(selectedFaction === 'slayer' ? slayerRanks : demonRanks).map(rank => (
                        <option key={rank.value} value={rank.value}>{rank.value} - {rank.label}</option>
                      ))}
                    </select>
                  </div>
                )}
                <div className="flex space-x-3 pt-4">
                  <button
                    onClick={() => setShowSetRankModal(false)}
                    className="flex-1 px-4 py-2 bg-gmod-lighterer text-gmod-white rounded-md hover:bg-gmod-lightest"
                  >
                    Отмена
                  </button>
                  <button
                    onClick={async () => {
                      if (!selectedFaction || !selectedRankNumber) return;
                      setSetRankLoading2(true);
                      try {
                        const rankLabel = (selectedFaction === 'slayer' ? slayerRanks : demonRanks)
                          .find(r => r.value === parseInt(selectedRankNumber))?.label || selectedRankNumber;
                        
                        await api.post(`/api/commands`, {
                          command: `SetFactionRank"${setRankModalPlayer2.steamId}"${selectedFaction}"${rankLabel}`,
                          target: setRankModalPlayer2.steamId,
                          reason: '',
                          duration: 0,
                          type: 'setrank'
                        }, { withCredentials: true });
                        
                        // Обновляем ранг в базе данных и локально
                        try {
                          const endpoint = selectedFaction === 'slayer' ? 'slayer-rank' : 'demon-rank';
                          // console.log('Отправляем запрос на обновление ранга:', {
                          //   steamId: setRankModalPlayer2.steamId,
                          //   endpoint,
                          //   rank: rankLabel
                          // });
                          
                          await api.post(`/api/players/${setRankModalPlayer2.steamId}/${endpoint}`, {
                            rank: rankLabel
                          }, { withCredentials: true });
                          
                          // Обновляем данные игрока локально
                          setPlayers(prevPlayers => 
                            prevPlayers.map(p => 
                              p.steamId === setRankModalPlayer2.steamId 
                                ? { ...p, [selectedFaction === 'slayer' ? 'slayerRank' : 'demonRank']: rankLabel }
                                : p
                            )
                          );
                          
                          // Уведомляем другие компоненты об обновлении только после успешного сохранения
                          window.dispatchEvent(new CustomEvent('playerRankUpdated', {
                            detail: {
                              steamId: setRankModalPlayer2.steamId,
                              faction: selectedFaction,
                              rank: rankLabel
                            }
                          }));
                        } catch (dbError) {
                          console.warn('Не удалось обновить ранг в базе данных:', dbError);
                          if (dbError.response?.status === 429) {
                            const retryAfter = dbError.response.data?.retryAfter || 60;
                            toast.error(`Слишком много запросов. Попробуйте через ${retryAfter} секунд`);
                          } else {
                            toast.error('Команда отправлена, но не удалось сохранить ранг в базе данных');
                          }
                          return;
                        }
                        
                        toast.success('Команда SetFactionRank отправлена');
                        setShowSetRankModal(false);
                        setSetRankModalPlayer2(null);
                        setSelectedFaction('');
                        setSelectedRankNumber('');
                        fetchPlayers();
                      } catch (e) {
                        toast.error(e?.response?.data?.error || 'Ошибка при выполнении команды');
                      } finally {
                        setSetRankLoading2(false);
                      }
                    }}
                    disabled={setRankLoading2 || !selectedFaction || !selectedRankNumber}
                    className="flex-1 px-4 py-2 bg-theme-primary text-gmod-white rounded-md hover:bg-theme-primary-hover"
                  >
                    {setRankLoading2 ? '...' : 'Выполнить'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Players; 